module.exports = __webpack_public_path__ + "static/media/logo-light-fr.44433693.svg";